export default "__VITE_ASSET__ed8bdd54__"